const keys = Object.keys;

const createListener = function(target, listeners, useCapture) {
    keys(listeners).forEach(function(key) {
        target.addEventListener(key, listeners[key], useCapture);
    });

    return {
        "_target": target,
        "_listeners": listeners,
        "_useCapture": useCapture,

        "destroy": function() {
            const target = this._target;
            const listeners = this._listeners;
            const useCapture = this._useCapture;
            if (target === null || listeners === null) {
                return;
            }

            this._target = null;
            this._listeners = null;
            this._useCapture = false;
            keys(listeners).forEach(function(key) {
                target.removeEventListener(key, listeners[key], useCapture);
            });
        }
    };
};

const wheelDelta = function(event) {
    let deltaX = 0;
    let deltaY = 0;

    if (event.type === "mousewheel") {
        deltaX = -(event.wheelDeltaX || 0);
        deltaY = -(event.wheelDeltaY || (deltaX === 0 ? event.wheelDelta : 0)) || 0;
    } else if (event.type === "wheel") {
        deltaX = event.deltaX;
        deltaY = event.deltaY;
    }

    return {
        "x": deltaX,
        "y": deltaY
    };
};

const classes = function(_class) {
    if (typeof _class === "string") {
        _class = [_class];
    }
    const classes = [];
    _class.forEach(function(cls) {
        cls.split().forEach(function(split) {
            classes.push(split);
        });
    });
    return classes;
};

const destroyElement = function(element) {
    const parent = element.parentNode;
    if (parent) {
        parent.removeChild(element);
    }

    let last = element.lastChild;
    while (last) {
        destroyElement(last);
        last = element.lastChild;
    }
};

export default {
    "createElement": function(tag, options) {
        const element = document.createElement(tag);

        if (options !== void 0) {
            keys(options).forEach(function(key) {
                const value = options[key];
                if (key === "class") {
                    element.setAttribute("class", classes(value).join(" "));
                } else if (key === "style") {
                    const style = element.style;
                    keys(value).forEach(function(styleKey) {
                        style[styleKey] = value[styleKey];
                    });
                } else if (key === "text") {
                    element.textContent = value;
                } else if (key === "attributes") {
                    keys(value).forEach(function(attr) {
                        element.setAttribute(attr, value[attr]);
                    });
                } else {
                    throw new Error("unexpected option '" + key + "'");
                }
            });
        }

        return element;
    },

    "destroyElement": destroyElement,

    "listen": function(target, type, _func, _useCapture) {
        const listeners = {};
        let useCapture = false;

        if (typeof type === "string") {
            listeners[type] = _func;
            useCapture = Boolean(_useCapture);
        } else {
            keys(type).forEach(function(key) {
                listeners[key] = type[key];
            });
            useCapture = Boolean(_func);
        }
        return createListener(target, listeners, useCapture);
    },

    "eventOffset": function(event, _element) {
        const element = _element || event.currentTarget;

        const rect = element.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * element.clientWidth;
        const y = ((event.clientY - rect.top) / rect.height) * element.clientHeight;
        return {
            "x": x,
            "y": y
        };
    },

    "wheelDelta": wheelDelta,

    "preventWheelGestures": function(event, _element) {
        const element = _element || event.currentTarget;
        const delta = wheelDelta(event);

        const left = element.scrollLeft;
        let ignoreX =
            (delta.x === 0) ||
            (delta.x > 0 && left >= element.scrollWidth - element.clientWidth) ||
            (delta.x < 0 && left <= 0);

        const top = element.scrollTop;
        let ignoreY =
            (delta.y === 0) ||
            (delta.y > 0 && top >= element.scrollHeight - element.clientHeight) ||
            (delta.y < 0 && top <= 0);

        // Workaround: In Chrome 31 scrollWidth - clientWidth may be 1 larger than
        // what scrollLeft can become. This can happen e.g. when the actual unrounded
        // clientWidth is fractional but gets rounded downward.
        // When we suspect such a thing might be happening we force vertical scrollbar to the
        // rightmost side (and hope that the user doesn't get bothered by it too much).
        if (!ignoreX && delta.x > 0 && left === element.scrollWidth - element.clientWidth - 1) {
            element.scrollLeft += 1;
            ignoreX = true;
        }
        // Same applies to scrollHeight - clientHeight and scrollTop.
        if (!ignoreY && delta.y > 0 && top === element.scrollHeight - element.clientHeight - 1) {
            element.scrollTop += 1;
            ignoreY = true;
        }

        if (ignoreX && ignoreY) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
        return true;
    }
};



// WEBPACK FOOTER //
// ./src/abusesa-js/ui/dom.js